import React from 'react';

export default function DeleteConfirmationModal({ isOpen, onConfirm, onCancel, contactName }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onCancel}
      />

      {/* Modal */}
      <div className="relative bg-gray-900 border border-white/20 rounded-3xl shadow-2xl max-w-md w-full p-6 space-y-6">
        <div className="text-center space-y-2">
          <h2 className="text-2xl font-bold text-white">
            Delete Contact
          </h2>
          <p className="text-gray-300">
            Are you sure you want to delete{' '}
            <span className="font-semibold text-white">
              {contactName || 'this contact'}
            </span>
            ? This action cannot be undone.
          </p>
        </div>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 px-6 py-3 rounded-2xl font-semibold text-white bg-white/10 hover:bg-white/20 transition-colors border border-white/15"
          >
            No, Keep It
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 px-6 py-3 rounded-2xl font-semibold text-white bg-red-600 hover:bg-red-500 transition-colors shadow-lg"
          >
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
}

